import * as React from "react";
import moment from "moment";
import styled from "../../lib/styled";
import { Link } from "gatsby";
import { presets } from "../../lib/presets";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

interface CountdownProps {
  icon: FontAwesomeIconProps["icon"];
  iconSet: "fas" | "fab";
  text: string;
  linkUrl?: string;
  linkText?: string;
}

const IconTextLink: React.FC<CountdownProps> = (props) => {
  return (
    <Wrapper className="icon-text-link--wrapper">
      <div className="icon-text-link--left">
        {/* 
        // @ts-ignore */}
        <FontAwesomeIcon icon={[props.iconSet, props.icon]} />
      </div>
      <div className="icon-text-link--right">
        <p className="icon-text-link--text">{props.text}</p>
        {props.linkUrl && (
          <GoToLink className="icon-text-link--link" to={props.linkUrl}>
            {props.linkText || "Read more"}
          </GoToLink>
        )}
      </div>
    </Wrapper>
  );
};

export default IconTextLink;

const Wrapper = styled.div`
  display: flex;
  margin: 10px 0;
  flex-direction: row;
  align-items: center;

  .icon-text-link--icon {
    font-size: 1.8rem;
    color: #ff4e00;
  }

  .icon-text-link--left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    svg {
      fill: ${({ theme }) => theme.color.accent};
    }
  }

  p.icon-text-link--text {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 20px;
    line-height: 1em;
    margin: 0;
    flex: 1;
  }
`;

const GoToLink = styled(Link)`
  font-family: "Keep Calm";
  color: ${({ theme }) => theme.color.accent};
  letter-spacing: 1px;
  font-size: 10px;
  text-transform: uppercase;
  margin: 0;
  text-decoration: none;
`;
